import { PQR_TIMES_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { usePqrTimesList } from './hook';
import { PqrTimesListProps } from './props';

export const PqrTimesList = ({ filters }: PqrTimesListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrTimesList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${PQR_TIMES_DETAIL}/${item.row.id}`, '_blank')
            }
        />
    );
};
